export class ViewPointSettings {
    public static readonly CANVAS_MIN_MARGIN_PX: number = 20;
    public static readonly MIN_ZOOM: number = 1;
    public static readonly MAX_ZOOM: number = 4;
    public static readonly ZOOM_STEP: number = 0.1;
    public static readonly TRANSLATION_STEP_PX: number = 20;
}